import { ModuleRoutes } from '@kiplin/web-common/architecture-core';
import { loadLazyAppModuleGuard } from '@kiplin/web-common/dependency-injection';
import { CommunicationKitRouteName } from '@client/feature/communication-kit/application/routes/communication-kit.route-name';
import { checkClientSelected } from '@client/common/router/application/routes/check-client-selected.route-guard';
import { checkCommunicationKitTemplateSelected } from '@client/feature/communication-kit/application/routes/check-communication-kit-template-selected.route-guard';
import type { Container } from 'inversify';
import type { RouteRecordRaw } from 'vue-router';

const CommunicationKitAppModule = () => import('@client/feature/communication-kit/communication-kit.app-module');
const CommunicationKitLayout = () =>
  import('@client/feature/communication-kit/application/layout/CommunicationKitLayout.vue');
const CommunicationKitChoosePage = () =>
  import('@client/feature/communication-kit/application/page/CommunicationKitChoosePage.vue');
const CommunicationKitCustomPage = () =>
  import('@client/feature/communication-kit/application/page/CommunicationKitCustomPage.vue');

type CommunicationKitRouteNameValue = (typeof CommunicationKitRouteName)[keyof typeof CommunicationKitRouteName];

export class CommunicationKitModuleRoutes extends ModuleRoutes<CommunicationKitRouteNameValue> {
  constructor(container: Container) {
    const routes: RouteRecordRaw[] = [
      {
        path: 'communication-kit',
        component: CommunicationKitLayout,
        beforeEnter: [loadLazyAppModuleGuard(CommunicationKitAppModule, container), checkClientSelected],
        children: [
          {
            path: '',
            redirect: { name: CommunicationKitRouteName.Template },
          },
          {
            path: 'template',
            name: CommunicationKitRouteName.Template,
            component: CommunicationKitChoosePage,
          },
          {
            path: 'custom/:templateId',
            name: CommunicationKitRouteName.Custom,
            component: CommunicationKitCustomPage,
            beforeEnter: checkCommunicationKitTemplateSelected,
          },
        ],
      },
    ];

    super(routes);
  }
}
